import React from 'react';
import PropTypes from 'prop-types';
import './Navbar.css'; // Create a separate CSS file if needed

function PopupModal({ isOpen, onClose, onSubmit, onChange, formData }) {
  if (!isOpen) return null;

  return (
    <div className="popup-modal" isOpen={isOpen}>
      <div className="popup-wrapper">
        <form onSubmit={onSubmit}>
          <div className="common-popup-container">
            <img
              className="common-popup-close"
              src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/close.svg"
              alt="close button"
              onClick={onClose}
            />

            <div className="common-popup-input-error-container">
              <input type="text" id="firstname" name="firstname" placeholder="First Name*" className="common-popup-input"  onChange={onChange} value={formData.firstname} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <input type="text" id="lastname" name="lastname" placeholder="Last Name*" className="common-popup-input"  onChange={onChange} value={formData.lastname} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <input type="text" id="company" name="company" placeholder="Company Name*" className="common-popup-input"  onChange={onChange} value={formData.company} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <input type="text" id="jobtitle" name="jobtitle" placeholder="Job Title*" className="common-popup-input"  onChange={onChange} value={formData.jobtitle} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <input type="email" id="email" name="email" placeholder="Business Email*" className="common-popup-input"  onChange={onChange} value={formData.email} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <input type="text" id="query" name="query" placeholder="Subject*" className="common-popup-input"  onChange={onChange} value={formData.query} required />
              <span className="common-popup-input-error"></span>
            </div>
            <div className="common-popup-input-error-container">
              <textarea rows="4" id="message" name="message" placeholder="Message*" className="common-popup-text-area"  onChange={onChange} value={formData.message} required></textarea>
              <span className="common-popup-input-error"></span>
            </div>
            <label className="common-popup-checkbox-label">
              <input type="checkbox" id="subscribe_to_zinnov_newsletter" name="subscribe_to_zinnov_newsletter" className="common-popup-checkbox"  onChange={onChange} value={formData.subscribe_to_zinnov_newsletter} />
              Subscribe to our newsletter
            </label>
            <button className="common-popup-submit" type="submit">
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

PopupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.func.isRequired
};

export default PopupModal;
